import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { ApplicationById, CommonBody } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import Loader from "../../constants/Loader";
import { Button, TextField } from "@mui/material";
import { isNumber } from "../../utils/validations";
import { useUpdateApplicationMutation } from "../../service/applications";

type props = {
  id: string | undefined;
  data?: ApplicationById | null;
};

const UpdateDays = ({ id, data }: props) => {
  const [loading, setLoading] = useState(false);
  const [updateApplication] = useUpdateApplicationMutation();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      payment_gap_days: data?.payment_gap_days || "",
    },

    validationSchema: Yup.object({
      payment_gap_days: Yup.string().required("This field is required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        payment_gap_days: values.payment_gap_days,
      };

      try {
        setLoading(true);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

        const response = await updateApplication({
          body: encryptedBody,
          id: Number(id),
        }).unwrap();

        if (response?.status === 200) {
          setLoading(false);

          successToast("Updated successfully");
        } else {
          setLoading(false);
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    },
  });

  return (
    <form
      className="form"
      onSubmit={formik.handleSubmit}
      style={{ marginTop: "20px" }}
    >
      <Loader isLoad={loading} />
      <div className="gap_p">
        <div className="control_group w_50">
          <label>No. of days between first payment and second payment</label>
          <TextField
            variant="outlined"
            placeholder="Enter here"
            fullWidth
            hiddenLabel
            name="payment_gap_days"
            id="payment_gap_days"
            className="text_field"
            inputProps={{ maxLength: 3 }}
            value={formik.values.payment_gap_days}
            onChange={(val) => {
              const input = val.target.value;

              if (
                input === "" ||
                (/^[1-9][0-9]{0,2}$/.test(input) && isNumber(input))
              ) {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={
              formik.touched.payment_gap_days && formik.errors.payment_gap_days
            }
          />
        </div>
      </div>
      <div className="form_btn end">
        <Button className="btn btn_secondary" type="submit">
          Update Changes
        </Button>
      </div>
    </form>
  );
};

export default UpdateDays;
